import React from "react";
import { Link } from "react-scroll";
import ASSETS from "../assets";

const Stat = ({ value, label }) => (
  <div className="text-center md:text-left">
    <div className="text-3xl md:text-xl font-extrabold text-gray-900">
      {value}
    </div>
    <div className="text-gray-600 mt-1">{label}</div>
  </div>
);

const Bar = ({ label, value }) => (
  <div>
    <div className="flex items-center justify-between text-sm text-gray-700">
      <span>{label}</span>
      <span className="font-medium">{value}%</span>
    </div>
    <div className="mt-2 h-2 rounded-full bg-gray-200 overflow-hidden">
      <div
        className="h-full bg-brand-yellow rounded-full"
        style={{ width: `${value}%` }}
      />
    </div>
  </div>
);

const AboutUs = () => {
  return (
    <section id="about" className="py-20 bg-white scroll-mt-20">
      <div className="container">
        {/* Mini hero heading with breadcrumb */}
        <div className="mb-12">
          <h2 className="text-brand-navy text-3xl font-semibold mb-6 uppercase tracking-wider text-center">
            About Us
          </h2>
        </div>

        {/* Intro two-column */}
        <div className="grid md:grid-cols-2 gap-10 items-center mb-16">
          <div className="card overflow-hidden transition-transform duration-300 will-change-transform motion-safe:hover:animate-float hover:shadow-lg">
            <img
              src={ASSETS.building}
              alt="Agricultural products"
              loading="lazy"
              className="w-full h-80 object-cover"
            />
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
              Quality Products, Trusted Service
            </h3>
            <p className="text-gray-600 mt-4">
              Established in 2015, Trust Import and Export is one of the leading
              agricultural commodity exporters in Ethiopia. We export beans,
              pulses, oil seeds, and spices to different continents such as USA,
              Europe, Asia, Africa, and North America.
            </p>
            <Link
              to="contact"
              smooth
              duration={500}
              offset={-80}
              className="btn-secondary mt-6 inline-flex cursor-pointer"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Skills + Stats */}
        <div className="grid md:grid-cols-2 gap-10 items-start mb-16">
          <div>
            <h4 className="text-2xl font-bold text-gray-900 mb-2">
              Our Core Capabilities
            </h4>
            <p className="text-gray-600 mb-6">
              At Trust Import and Export, we believe that securing quality and
              providing quality products is a mandatory requirement in market
              competition. We clean, sort, process, and package our agricultural
              products to meet our customer's requirements and standards.
            </p>
            <div className="space-y-5">
              <Bar label="Quality Processing" value={95} />
              <Bar label="Export Excellence" value={90} />
              <Bar label="Customer Satisfaction" value={88} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8">
            <Stat value="2015" label="Established" />
            <Stat value="5+" label="Continents Served" />
            <Stat value="100%" label="Quality Focus" />
            <Stat value="3" label="Core Services" />
          </div>
        </div>

        {/* CTA banner */}
        <div className="relative card overflow-hidden">
          <img
            src={ASSETS.building}
            alt="Agricultural products"
            loading="lazy"
            className="w-full h-72 md:h-80 object-cover"
          />
          <div className="absolute inset-0 bg-brand-navy/60" />
          <div className="absolute inset-0 flex items-center justify-center text-center px-6">
            <div>
              <p className="uppercase text-white/80">Partner With Us</p>
              <h3 className="text-2xl md:text-3xl font-extrabold text-white mt-1">
                Ready To Export Quality
                <br className="hidden md:block" /> Agricultural Products
              </h3>
              <Link
                to="contact"
                smooth
                duration={500}
                offset={-80}
                className="mt-5 inline-flex bg-white text-gray-900x font-semibold px-5 py-3 rounded-full shadow-soft cursor-pointer"
              >
                Start Your Order
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
